// Module
var code = `<dialog class="dialog-conditions">
    <h3>syscall conditions</h3>
    <ul class="syscall-conditions"></ul>
    <form method="dialog"><input type=submit value="close"></form>
</dialog>`;
// Exports
export default code;